import { API_URL_WS_FORMULAIRE, APP_URL_APPLICATION } from '@amo/core/constants/constants.js';
import { getVehicleHolderName } from '@amo/core/utils/functions';
import moment from 'moment';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import {formValueSelector, getFormValues} from 'redux-form';
import { POST_PAY_EMBEDDED, postPayEmbedded } from '../../../../../redux/actions/app/pay/pay.action';
import {postReloadTarif, TARIF} from '../../../../../redux/actions/app/tarif/tarif.actions';
import {
    getFractionnementPoliceDemandeTarifInit,
    getNameSouscripteurDemandeTarif,
    getToken
} from '../../../../../redux/selectors/init/init.selectors';
import {
    getInfoCodePromo,
    getListeFormulesTarif,
    isLoadedTarif,
} from '../../../../../redux/selectors/tarif/tarif.selectors';
import {
    getLoadingEntity,
    getPrixTotal,
    getPrixTotalAnnuel,
    getPrixTotalAnnuelPromo,
    getPrixTotalPromo,
} from '../../../../../redux/selectors/ui/ui.selectors';
import { getVehicule } from '../../../../../redux/selectors/vehicule/vehicule.selectors';
import Recapitulatif from './Recapitulatif';
import {
    getUrlPDFDevisInit,
    getUrlPDFFicheConseilInit
} from "formulaire-courtier/src/redux/selectors/init/init.selectors.js";
import {
    getUrlPDFConventionAssistanceTarif,
    getUrlPDFDispositionsGeneralesTarif, getUrlPDFDocumentInformationTarif, getUrlPDFLettreRGPDTarif
} from "formulaire-courtier/src/redux/selectors/tarif/tarif.selectors.js";
import {getDejaClient} from "../../../../../redux/selectors/dejaClient/dejaClient.selectors.js";
import {loader} from "@amo/core/components/loaders/index.js";

const mapStateToProps = (state) => {
    const selector = formValueSelector('devis-direct');
    const titulaireCarteGriseSo = selector(state, 'titulaireCarteGrise') === '2';
    const datenaissanceCond = selector(state, 'DemandeTarif[ListePersonnes][0][DateNaissance]');
    const mineur =
        datenaissanceCond &&
        moment.isMoment(datenaissanceCond) &&
        moment(datenaissanceCond).add(18, 'years') > moment();

    let nomPrenomTitulaire =
        selector(state, 'DemandeTarif[ListePersonnes][0][Nom]') +
        ' ' +
        selector(state, 'DemandeTarif[ListePersonnes][0][Prenom]');
    if (titulaireCarteGriseSo) {
        nomPrenomTitulaire = selector(state, 'DemandeTarif[ListePersonnes][1][Nom]');
    } else if (mineur) {
        nomPrenomTitulaire =
            selector(state, 'DemandeTarif[ListePersonnes][1][Nom]') +
            ' ' +
            selector(state, 'DemandeTarif[ListePersonnes][1][Prenom]');
    }

    return {
        loaded: getLoadingEntity(state, TARIF) === false,
        nomSouscripteur: getNameSouscripteurDemandeTarif(state),
        vehicule: getVehicule(state),
        formules: getListeFormulesTarif(state),
        fractionnementChoisi: getFractionnementPoliceDemandeTarifInit(state),
        query: `${API_URL_WS_FORMULAIRE}/pay-embedded/${getToken(state)}`,
        url_pay: {
            token: getToken(state),
            url_return: `${APP_URL_APPLICATION}`,
        },
        payLoaded: getLoadingEntity(state, POST_PAY_EMBEDDED),
        nomTitulaireCg: getVehicleHolderName(
            selector(state, 'DemandeTarif[ListePersonnes]'),
            selector(state, 'titulaireCarteGrise'),
        ),
        nomPrenom: nomPrenomTitulaire,
        isLoadedTarif: isLoadedTarif(state),
        queryTarif: `${API_URL_WS_FORMULAIRE}/get_tarif/${getToken(state)}`,
        prixTotalMensuel: getPrixTotal(state),
        prixTotalMensuelPromo: getPrixTotalPromo(state),
        prixTotalAnnuel: getPrixTotalAnnuel(state),
        prixTotalAnnuelPromo: getPrixTotalAnnuelPromo(state),
        codePromo: getInfoCodePromo(state),
        isDejaClient: getDejaClient(state),
        souscripteurIsSociety:
            (selector(state, 'DemandeTarif[ListePersonnes][1][TypePersonne]') === 'M' &&
                selector(state, 'DemandeTarif[ListePersonnes][1][Civilite]') === '3') ||
            false,
        pdfDevis: getUrlPDFDevisInit(state),
        dispositionGenerale: getUrlPDFDispositionsGeneralesTarif(state),
        documentInformation: getUrlPDFDocumentInformationTarif(state),
        lettreRGPD: getUrlPDFLettreRGPDTarif(state),
        assistancePanne: getUrlPDFConventionAssistanceTarif(state),
        formValues: getFormValues('devis-direct')(state),
        dateMEC: moment.isMoment(selector(state, 'DemandeTarif[Vehicule][DateMEC]'))
            ? selector(state, 'DemandeTarif[Vehicule][DateMEC]').format('DD/MM/YYYY')
            : selector(state, 'DemandeTarif[Vehicule][DateMEC]')
    };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            postPayEmbedded,
            postReloadTarif,
        },
        dispatch,
    );

const mergeProps = (stateProps, dispatchProps, ownProps) => {
    const { url_pay, query, queryTarif } = stateProps;
    const { postPayEmbedded, postReloadTarif } = dispatchProps;
    const { data } = ownProps;

    return {
        ...ownProps,
        ...stateProps,
        ...dispatchProps,
        postPaySubmit: () => postPayEmbedded({ form: data, query, url_pay }),
        load: () => postReloadTarif({ form: data, query: queryTarif })
    };
};

const RecapitulatifContainer = compose(
    connect(mapStateToProps, mapDispatchToProps, mergeProps),
    loader()
)(Recapitulatif);

export default RecapitulatifContainer;
